import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DataLayer {
    public startPageTracking(): void {
        document.dispatchEvent(new CustomEvent<TDigitalDataEventParam>('c-tracking-log-page-start', {
            bubbles: true
        }));
    }

    public trackPageInfo(): void {
        document.dispatchEvent(new CustomEvent('c-tracking-log-page', {
            bubbles: true,
            detail: window.digitalDataLegacy
        }));
    }

    public trackEvent(event: object): void {
        document.body.dispatchEvent(new CustomEvent('c-tracking-log-dom', {
            bubbles: true,
            detail: event
        }));
    }

    public sendUpdate(params: object): void {
        document.body.dispatchEvent(new CustomEvent('c-tracking-log-update', {
            bubbles: true,
            detail: params
        }));
    }

    /**
     * DO NOT USE....EVER
     *
     * If you think this is required, have a team discussion first. This function should only be used when
     * you need to manually set the digitalData object directly.
     */
    public _forceUpdate(params: object): void {
        document.dispatchEvent(new CustomEvent('c-tracking-log', {
            bubbles: true,
            detail: {
                digitalData: params
            }
        }));
    }
}
